/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {SERVER_HTTP_PROVIDERS as ɵangular_packages_platform_server_platform_server_g,ServerXhr as ɵangular_packages_platform_server_platform_server_e,zoneWrappedInterceptingHandler as ɵangular_packages_platform_server_platform_server_f} from './src/http';
export {instantiateServerRendererFactory as ɵangular_packages_platform_server_platform_server_a} from './src/server';
export {ServerEventManagerPlugin as ɵangular_packages_platform_server_platform_server_d} from './src/server_events';
export {ServerStylesHost as ɵangular_packages_platform_server_platform_server_c} from './src/styles_host';
export {serializeTransferStateFactory as ɵangular_packages_platform_server_platform_server_b} from './src/transfer_state';